import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import '@core/scss/vue/libs/vue-sweetalert.scss'

Vue.use(VueSweetalert2)
